import React, { useEffect } from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { HonorarioCreationContent } from './components/HonorarioCreationContent';
import { useLocation } from 'react-router-dom';

export default function HonorarioCreation() {
    const location = useLocation();
    const { isNew, allowedWrite } = location.state;

    return (
        <MainContent
            component={<HonorarioCreationContent />}
            titulo={`${allowedWrite ? ((isNew) ? 'Nuevo ' : 'Editar ') : ''} Honorario`}
            noBackground
            tableMaxWidth
        />
    );

};
